import { useState, useEffect, useCallback } from 'react';
import TagManager from 'react-gtm-module';
import { APP_CONFIG } from '@vmos2/core';
import { useHybridApp } from './useHybridApp';

export const useGoogleTagManager = settings => {
  const [gtm, setGtm] = useState<string | null>(null);
  const { hybridApp, isLoading } = useHybridApp();
  const { gtm: gtmWeb, gtmAndroid, gtmIos } = settings;

  const getGtmId = () => {
    if (hybridApp?.isReactNativeApp) {
      return hybridApp.platformId === 'android' ? gtmAndroid?.value : gtmIos?.value;
    }

    return gtmWeb || APP_CONFIG?.GTM_ID || null;
  };

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const gtmId = getGtmId();

    if (gtmId) {
      setGtm(gtmId);
    }
  }, [hybridApp, gtmWeb, gtmAndroid, gtmIos, isLoading]);

  const initializeGTM = useCallback(() => {
    if (!gtm || !settings || (window.dataLayer && window.dataLayer.some(element => element['gtm.start']))) {
      return;
    }

    TagManager.initialize({ gtmId: gtm });
  }, [gtm, settings]);

  return { gtm, initializeGTM };
};
